"use client";

import { useEffect, useState } from "react";
import { ENGLISH_FALLBACK_NOTICE } from "@marketing-sites/l10n/preference/locale-names";
import { cn } from "@marketing-sites/utils/cn";
import {
  readStorageItem,
  writeStorageItem,
} from "@marketing-sites/utils/safe-storage";

const DISMISSED_STORAGE_KEY = "localeFallbackNoticeDismissed";

export interface EnglishFallbackNoticeProps {
  preferredPrefix: string | null;
  isPrefixedPath: boolean;
  hasPreferredTranslation: boolean;
  resolveHref: (prefix: string) => string;
  className?: string;
  linkClassName?: string;
  dismissClassName?: string;
}

export function EnglishFallbackNotice({
  preferredPrefix,
  isPrefixedPath,
  hasPreferredTranslation,
  resolveHref,
  className,
  linkClassName,
  dismissClassName,
}: EnglishFallbackNoticeProps) {
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    setIsDismissed(
      readStorageItem("session", DISMISSED_STORAGE_KEY) === "true",
    );
  }, []);

  if (
    !preferredPrefix ||
    isPrefixedPath ||
    hasPreferredTranslation ||
    isDismissed
  )
    return null;

  const copy = ENGLISH_FALLBACK_NOTICE[preferredPrefix];
  if (!copy) return null;

  function handleDismiss() {
    writeStorageItem("session", DISMISSED_STORAGE_KEY, "true");
    setIsDismissed(true);
  }

  return (
    <div className={cn("flex items-center justify-between gap-3", className)}>
      <p>
        {copy.message}{" "}
        <a href={resolveHref(preferredPrefix)} className={linkClassName}>
          {copy.action}
        </a>
      </p>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label={copy.dismiss}
        className={dismissClassName}
      >
        ×
      </button>
    </div>
  );
}
